const setRedirectStore = (page, returnUrl) => {
    sessionStorage.setItem("urlRedirect", returnUrl);
    setTimeout(() => {
        window.location.href = page;
    }, 1000);
};

(function () {
    const BUTTON_SELECTOR = ".product__favorite-app-button";
    const APP_ICON_SELECTOR = "#st_add_icon, #st_details_icon";

    function isAppAvailable(button) {
        return button.classList.contains("st-initialized") || Boolean(document.querySelector(APP_ICON_SELECTOR));
    }

    function isActiveButton(button) {
        const signal = [
            button.getAttribute("aria-label"),
            button.getAttribute("title"),
            button.textContent
        ].join(" ").toLowerCase();

        const useHref = (
            button.querySelector("use")?.getAttribute("xlink:href") ||
            button.querySelector("use")?.getAttribute("href") ||
            ""
        ).toLowerCase();

        return (
            button.classList.contains("is-active") ||
            button.classList.contains("active") ||
            button.classList.contains("added") ||
            button.classList.contains("selected") ||
            button.getAttribute("aria-pressed") === "true" ||
            signal.includes("remover") ||
            signal.includes("remove") ||
            signal.includes("favoritado") ||
            signal.includes("added") ||
            useHref.includes("added") ||
            useHref.includes("remove")
        );
    }

    function getLabelText(button) {
        return isActiveButton(button) ? "Favoritado" : "Favoritar";
    }

    function syncWishlistLabels() {
        document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
            if (!isAppAvailable(button)) {
                button.setAttribute("aria-hidden", "true");
                return;
            }

            button.removeAttribute("aria-hidden");
            button.setAttribute("data-wishlist-label", getLabelText(button));
        });
    }

    function bindButtonEvents() {
        document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
            if (button.dataset.wishlistLabelBound === "true") {
                return;
            }

            button.dataset.wishlistLabelBound = "true";

            button.addEventListener("click", function () {
                syncWishlistLabels();
                window.setTimeout(syncWishlistLabels, 150);
                window.setTimeout(syncWishlistLabels, 400);
                window.setTimeout(syncWishlistLabels, 900);
            });
        });
    }

    let syncTimeoutId = null;

    function scheduleSync() {
        window.clearTimeout(syncTimeoutId);
        syncTimeoutId = window.setTimeout(function () {
            bindButtonEvents();
            syncWishlistLabels();
        }, 120);
    }

    document.addEventListener("DOMContentLoaded", scheduleSync);
    document.addEventListener("shopify:section:load", scheduleSync);
    document.addEventListener("quickview:loaded", scheduleSync);
    document.addEventListener("product:variant-change", scheduleSync);

    const observer = new MutationObserver(function () {
        scheduleSync();
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "aria-pressed", "aria-label", "title", "href", "xlink:href"]
    });
})();
